<div>
  <table class="case-requirements-table">
    <thead>
      <tr>
        <th class="icon-button-cell"></th>
        <th></th>
        <th>{{'Case.Requirements.Claim' | translate}}</th>
        <th>{{'Case.Requirements.Paid' | translate}}</th>
        <th>{{'Case.Requirements.Rest' | translate}} {{firmCurrencyCode}}</th>
        <th *ngIf="hasInternationalCurrency">
          {{'Case.Requirements.Rest' | translate}} {{case?.currencyCode}}
        </th>
        <th>{{'Case.Requirements.Invoiced' | translate}}</th>
        <th>{{'Case.Requirements.Remitted' | translate}}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="icon-button-cell"></td>
        <th>{{'Case.Requirements.Capital' | translate}}</th>
        <td>{{case?.requirements.originalCapital | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td>{{case?.requirements.paidCapital | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td>{{case?.requirements.restCapital | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td *ngIf="hasInternationalCurrency"> {{case?.requirements.restValutaCapital | number : numberFormat?.style:
          numberFormat?.culture}}</td>
        <td></td>
        <td>{{case?.requirements.remittedCapital | number : numberFormat?.style: numberFormat?.culture}}</td>
      </tr>
      <tr>
        <td class="icon-button-cell"></td>
        <th>
          <div class="interest-rate">
            {{'Case.Requirements.Interest' | translate}}
            <div>{{ case?.requirements.interestRate | number }}%</div>
          </div>
        </th>
        <td>{{case?.requirements.originalInterest | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td>{{case?.requirements.paidInterest | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td>{{case?.requirements.restInterest | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td *ngIf="hasInternationalCurrency">
          {{case?.requirements.restValutaInterest | number : numberFormat?.style: numberFormat?.culture}}
        </td>
        <td></td>
        <td>{{case?.requirements.remittedInterest | number : numberFormat?.style: numberFormat?.culture}}</td>
      </tr>

      <tr>
        <td class="icon-button-cell" (click)="showDetailedFees = !showDetailedFees">
          <i class="fa" [ngClass]="showDetailedFees ? 'fas fa-chevron-up fa-xs' : 'fas fa-chevron-down fa-xs'"></i>
        </td>
        <th>{{'Case.Requirements.ClaimType.Costs' | translate}}</th>
        <td>{{SveasFees?.original | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td>{{SveasFees?.paid | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td>{{SveasFees?.rest| number : numberFormat?.style: numberFormat?.culture}}</td>
        <td *ngIf="hasInternationalCurrency">
          {{SveasFees?.restValuta | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td>{{case?.requirements.customersAdditionalFee | number : numberFormat?.style: numberFormat?.culture}}
        </td>
        <td>{{SveasFees?.remitted| number : numberFormat?.style: numberFormat?.culture}}</td>
      </tr>

      @for(fee of DetailedFees; track fee.translationTag){
      <tr [ngClass]="{'hidden': !showDetailedFees, 'detailed-fees-row': true}">
        <td class="icon-button-cell"></td>
        <th class="detailed-fees-heading">
          <div [ngClass]="{'interest-rate': (fee.rate && fee.rate > 0)}">
            <div class="detailed-fees-label">{{ fee.translationTag | translate }}</div>
            @if(fee.rate){
            <div>{{ fee.rate | number }}%</div>
            }
          </div>
        </th>
        <td>{{ fee.original | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td>{{ fee.paid | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td>{{ fee.rest | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td *ngIf="hasInternationalCurrency">
          {{ fee.restValuta | number : numberFormat?.style: numberFormat?.culture}}
        </td>
        <td>{{fee.invoiced | number : numberFormat?.style: numberFormat?.culture}}
        </td>
        <td>{{ fee.remitted | number : numberFormat?.style: numberFormat?.culture}}</td>
      </tr>
      }
      
      @if (firmClaimSettings?.isCustomerReminderFeeEnabled === true) {
        <tr>
          <td class="icon-button-cell"></td>
          <th>{{'Case.Requirements.CustomerReminderFee' | translate}}</th>
          <td>{{case?.requirements.originalCustomerReminderFee | number : numberFormat?.style: numberFormat?.culture}}</td>
          <td>{{case?.requirements.paidCustomerReminderFee | number : numberFormat?.style: numberFormat?.culture}}</td>
          <td>{{case?.requirements.restCustomerReminderFee | number : numberFormat?.style: numberFormat?.culture}}</td>
          <td *ngIf="hasInternationalCurrency">
            {{case?.requirements.restValutaCustomerReminderFee | number : numberFormat?.style: numberFormat?.culture}}
          </td>
          <td>{{case?.requirements.customersCustomerReminderFee | number : numberFormat?.style: numberFormat?.culture}}</td>
          <td>{{case?.requirements.remittedCustomerReminderFee | number : numberFormat?.style: numberFormat?.culture}}</td>
        </tr>
      }
     
      <tr>
        <td class="icon-button-cell"></td>
        <th>{{'Case.Requirements.PublicFee' | translate}}</th>
        <td>{{case?.requirements.originalPublicFee | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td>{{case?.requirements.paidPublicFee | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td>{{case?.requirements.restPublicFee | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td *ngIf="hasInternationalCurrency">
          {{case?.requirements.restValutaPublicFee | number : numberFormat?.style: numberFormat?.culture}}
        </td>
        <td>{{case?.requirements.customersPublicFee | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td>{{case?.requirements.remittedPublicFee | number : numberFormat?.style: numberFormat?.culture}}</td>
      </tr>
      <tr>
        <td class="icon-button-cell"></td>
        <th>{{'Case.Requirements.Total' | translate}}</th>
        <td>{{totals?.originalTotal | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td>{{totals?.paidTotal | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td>{{case?.requirements.restTotal | number : numberFormat?.style: numberFormat?.culture}}</td>
        <td *ngIf="hasInternationalCurrency">
          {{case?.requirements.restValutaTotal | number : numberFormat?.style: numberFormat?.culture}}
        </td>
        <td>
          {{(case ? (case.requirements.customersAdditionalFee + case.requirements.customersPublicFee) : undefined)
          | number : numberFormat?.style: numberFormat?.culture}}
        </td>
        <td>{{totals?.remitted | number : numberFormat?.style: numberFormat?.culture}}</td>
      </tr>
    </tbody>
  </table>
</div>